<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter-number---IVP sigil_not_in_toc"><span epub:type="pagebreak" id="pagev" title="v"></span></h1>
<p class="firstcenter">To</p>
<p class="firstcenter"><i>Tabitha Kapic</i></p>
<p class="firstcenter">You embody courage and love</p>
<p class="firstcenter">I can’t thank God enough for you<br/><br/></p>
<p class="firstcenter"><i>Jonathan and Margot Kapic</i></p>
<p class="firstcenter">Your faith, joy, and forgiveness are precious gifts to us<br/><br/></p>
<p class="firstcenter">&amp; <br/><br/></p>
<p class="firstcenter">To those who have supported us so well, especially</p>
<p class="firstcenter"><i>Our families and friends</i></p>
<p class="firstcenter"><i>The Covenant College community</i></p>
<p class="firstcenter"><i>New City Fellowship</i></p>
<p class="firstcenter"><i>Lookout Mountain Presbyterian Church</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_dedication.vue?921d3fd0